<template>
  <div class="ms-container">
    <div class="user-profile">
      <module-header>
        Настройки пользователя <strong>{{ user.username }}</strong>
      </module-header>
      <div class="user-profile__container">
        <div class="user-profile__left">
          <Anchor :affix="false">
            <AnchorLink href="#profile" title="Личные данные" />
            <AnchorLink href="#change-password" title="Изменить пароль" />
            <AnchorLink href="#system-settings" title="Настройки системы" />
            <AnchorLink href="#notifications" title="Уведомления" />
          </Anchor>
        </div>
        <div class="user-profile__right">
          <div class="user-profile__block" id="profile">
            <profile-info />
          </div>
          <div class="user-profile__block" id="change-password">
            <change-password />
          </div>
          <div class="user-profile__block" id="system-settings">
            <system-settings />
          </div>
          <div class="user-profile__block" id="notifications">
            <notifications />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileInfo from '@/components/profile/profile-info'
import ChangePassword from '@/components/profile/change-password'
import SystemSettings from '@/components/profile/system-settings'
import Notifications from '@/components/profile/notifications'
import ModuleHeader from '@/components/parts/module-header'

export default {
  components: {
    ProfileInfo,
    ChangePassword,
    SystemSettings,
    Notifications,
    ModuleHeader
  },
  computed: {
    user () {
      return this.$store.state.auth.user || {}
    }
  }
}
</script>

<style lang="less">
.user-profile {
  &__container {
    display: flex;
  }

  &__left {
    width: 280px;
    margin-right: 16px;
    font-size: 14px;

    .ivu-anchor-link {
      padding: 16px;
    }
  }

  &__right {
    flex: 1;
  }

  &__block {
    &:not(:first-child) {
      margin-top: 24px;
    }
  }
}
</style>
